<template>
	<div>
		<v-navigation-drawer fixed v-model="navStateFilter" :clipped="$vuetify.breakpoint.lgAndUp" app right class="mt-0" style="top: 0; height: 100%; max-height: 100%">
			<v-card-title>
				{{ this.$vuetify.lang.t('$vuetify.front.filters') }}
				<v-spacer></v-spacer>
			</v-card-title>
			<v-list dense>
				<v-list-item>
					<v-text-field hide-details="auto" @keyup="searchit" v-model="searchfield" append-icon="search" label="Search"></v-text-field>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>

		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center v-resize="onResize">
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.attributes') }}</v-toolbar-title>

							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<!--<v-btn text :href="linkdownload+'?search='+searchfield+'&categories='+settings.filters.categories+'&selected='+selected" exact >
                                    <v-icon>mdi-arrow-collapse-down</v-icon>
                                </v-btn>-->
								<!-- <v-divider vertical></v-divider>-->
								<v-btn text @click="toggleDrawerFilter">
									<v-icon>mdi-magnify</v-icon>
								</v-btn>
								<v-btn text @click="createItem">
									<v-icon>mdi-plus</v-icon>
								</v-btn>
							</v-toolbar-items>
						</v-toolbar>

						<v-card v-if="selected.length > 0" elevation="0" outlined>
							<v-tabs dark background-color="primary " show-arrows>
								<v-tabs-slider color="primary "></v-tabs-slider>

								<v-tab>
									{{ selected.length }}
									<span v-if="selected.length === 1" style="margin-left: 1rem"> selezionato </span>
									<span v-else style="margin-left: 1rem"> selezionati </span>
								</v-tab>

								<v-tab @click="editItem" v-if="selected.length === 1"> modifica </v-tab>
								<v-tab @click="deleteItem"> elimina </v-tab>
								<!--<v-tab :href="this.getUrl+'categories/download?token='+this.getToken+'&search='+this.searchfield+'&categories='+this.settings.filters.categories+'&selected='+this.selected">
                                    Download
                                </v-tab>-->
							</v-tabs>
						</v-card>

						<v-data-table
							v-if="!_.isEmpty(langDefault)"
							v-model="selectedall"
							:headers="headers"
							:items="getAttributes"
							@input="toggle"
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="item._id"
							show-select
							:sort-by="['created_at']"
							:sort-desc="[true]"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni riga diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="snapshot-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length + 1" class="px-3 py-1">
											<key-value-card :title="item.text || '-'" :fields="campiCard(item)">
												<template v-slot:actions>
													<v-checkbox class="mt-0 pt-0" v-model="selected" :value="item._id" color="primary" hide-details></v-checkbox>
													<v-menu top eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon v-bind="attrs" v-on="on" color="primary" small>
																<v-icon> mdi-dots-vertical </v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link @click="editItem(item)">
																<v-list-item-title class="size9">Modifica</v-list-item-title>
															</v-list-item>
															<v-list-item link @click="deleteItem(item)">
																<v-list-item-title class="size9">Elimina</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<div class="d-flex align-center justify-space-between">
													<span class="card-label">Status</span>
													<v-switch v-model="item.is_active" @change="changeStatus(item._id)" color="primary" class="mt-0 pt-0" hide-details></v-switch>
												</div>
												<div v-if="item.values && item.values.length" class="mt-2">
													<span class="card-label">Valori</span>
													<div>
														<v-chip v-for="(value, index2) in item.values" :key="index2" small class="mr-1 mt-1">
															{{ nomeValore(value) }}
														</v-chip>
													</div>
												</div>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr v-for="item in items" :key="item._id">
										<!-- v-bind:class="toggleClass(1)"-->
										<!--<td >  <v-checkbox color="blue" v-model="selected" :value="item" hide-details style="margin-top: 0px;padding-top: 0px;" ></v-checkbox></td>-->
										<td>
											<v-checkbox class="mt-0" v-model="selected" :value="item._id" color="primary" hide-details></v-checkbox>
										</td>
										<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px">
											<v-menu top eager>
												<template v-slot:activator="{ on, attrs }">
													<v-btn icon dark v-bind="attrs" v-on="on" color="primary" dense>
														<v-icon dark> mdi-dots-vertical </v-icon>
													</v-btn>
												</template>
												<v-list>
													<v-list-item link @click="editItem(item)">
														<v-list-item-title class="size9">Modifica</v-list-item-title>
													</v-list-item>
													<v-list-item link @click="deleteItem(item)">
														<v-list-item-title class="size9">Elimina</v-list-item-title>
													</v-list-item>
													<!-- <v-list-item link @click="moveItem(item)">
                                             <v-list-item-title class="size9">Sposta reference</v-list-item-title>
                                         </v-list-item>
                                         <v-list-item link @click="copyItem(item)">
                                             <v-list-item-title class="size9">Copia reference</v-list-item-title>
                                         </v-list-item>-->
												</v-list>
											</v-menu>
										</td>
										<td>
											<v-switch v-model="item.is_active" @change="changeStatus(item._id)" color="primary" class="mt-0" hide-details></v-switch>
										</td>
										<td>{{ item.created_at | moment('DD/MM/YYYY') }}</td>
										<td>{{ item.text }}</td>
										<td>
											<v-chip v-for="(value, index2) in item.values" :key="index2" class="ma-2" filter>
												{{ _.find(value.trans, { lang: langDefault }).name }}
											</v-chip>
										</td>
										<td>{{ item.filter }}</td>
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar = false"> Close </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>

		<v-dialog :eager="true" :retain-focus="false" :value="getDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
			<FormEdit v-if="operation === 'FormEdit'" :key="componentKey" :attribute="setIndex" @message="propSetMessages"></FormEdit>
			<FormCreate v-if="operation === 'FormCreate'" :key="componentKey" @message="propSetMessages"></FormCreate>
			<FormFile v-if="operation === 'FormFile'" :key="componentKey" @message="propSetMessages"></FormFile>
		</v-dialog>

		<v-dialog v-model="dialogconfirm" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Eliminando l'elemento selezionato non potrai più ripristinarlo.</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn color="primary" text @click="confirmDelete"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';

import KeyValueCard from '@/components/core/KeyValueCard.vue';

const FormCreate = () => import('@/components/attributes/CreateInDialog.vue');
const FormEdit = () => import('@/components/attributes/EditInDialog.vue');
const FormFile = () => import('@/components/categories/File.vue');

export default {
	name: 'Attributes',
	data() {
		return {
			componentKey: 0,
			right: true,
			permanent: false,
			miniVariant: false,
			expandOnHover: false,
			background: false,
			clippedOrder: 0,
			linkdownload: '',
			paramsUrls: '',

			items: [],
			setinterval: '',

			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca
			settings: {
				search: '',
				filters: {
					firstlevel: '',
					secondlevel: '',
					thirdlevel: '',
					fourthlevel: '',
					categories: [],
				},
				options: {
					sortBy: ['id'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			},
			listSize: [15, 25, 50, 100],

			searchfield: '',
			selected: [],
			selectedall: [],

			total: 0,

			headers: [
				{ text: '', value: '' },
				{ text: 'Status', value: 'is_active' },
				{ text: 'Created', value: 'created_at' },
				{ text: 'Nome', value: 'text' },
				{ text: 'Valori', value: '', sortable: false },

				{ text: 'Filtro', value: '', sortable: false },
			],

			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,

			dialogconfirm: false,

			isActive: true,

			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},

			firstLevel: [],
			secondLevel: [],
			thirdLevel: [],
			fourthLevel: [],
			listCategories: [],
			treeCategories: [],
			arrayTree: [],
			Totale: '',
			Fee: '',
			Refund: '',
			Gain: '',
			page: 1,

			isMobile: false,

			operation: '',
			getAttributes: [],
			langDefault: '',
			setIndex: '',
		};
	},
	/*created () {
            this.setDialog(false)
            this.initialize();

        },*/
	filters: {
		fixed: function (value) {
			if (!value) return '';
			return value.toFixed(2);
		},
	},
	async mounted() {
		let date = moment().format('YYYYMMDD');
		console.log('date', date);
		let pastdata = moment().subtract(2, 'days').format('YYYYMMDD');
		let part = 1;
		let hour = moment().format('HH');
		let day = moment().format('DD');

		if (+hour < 6) {
			part = 1;
		} else if (+hour >= 6 && +hour < 12) {
			part = 2;
		} else if (+hour >= 12 && +hour < 18) {
			part = 3;
		} else {
			part = 4;
		}

		this.setDialog(false);
		this.setExistFilter(true);

		await this.fetchSetting();

		this.langDefault = _.find(this.getSettings.languages, { default: true }).lang;
		_.forEach(this.getSettings.attributes, attr => {
			var text = _.find(attr.trans, { lang: this.langDefault });
			_.assignIn(attr, { text: text.name });
		});
		this.getAttributes = this.getSettings.attributes;
	},
	watch: {
		selectedLength(val) {
			if (val > 0) {
				this.selectedall = [-1];
			}
		},

		fab: {
			top(val) {
				this.fab.bottom = !val;
			},
			right(val) {
				this.fab.left = !val;
			},
			bottom(val) {
				this.fab.top = !val;
			},
			left(val) {
				this.fab.right = !val;
			},
		},
	},
	components: {
		FormCreate,
		FormEdit,
		FormFile,
		KeyValueCard,
		//VuetifyDraggableTreeview
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		selectedLength() {
			return this.selected.length;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getUrl: 'settings/getUrl',

			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getIndex: 'categories/getIndex',

			getCategories: 'categories/getCategories',
			getLanguage: 'profile/getLanguage',
			getDrawerFilter: 'settings/getDrawerFilter',
			getSortBy: 'categories/getSortBy',
			getSortDesc: 'categories/getSortDesc',
			getSettings: 'settings/getSetting',
		}),

		navStateFilter: {
			get: function () {
				return this.getDrawerFilter;
			},
			set: function () {
				return this.getDrawerFilter;
			},
		},
		navStateOrder: {
			get: function () {
				return this.clippedOrder;
			},
			set: function () {
				return this.clippedOrder;
			},
		},
	},

	methods: {
		// coppie chiave/valore della card su telefono
		campiCard(item) {
			const filtro = typeof item.filter === 'boolean' ? (item.filter ? 'Sì' : 'No') : item.filter;
			return [
				{ label: 'Created', value: item.created_at ? this.$moment(item.created_at).format('DD/MM/YYYY') : '' },
				{ label: 'Filtro', value: filtro },
			];
		},
		// nome del valore nella lingua di default
		nomeValore(value) {
			const found = _.find(value.trans, { lang: this.langDefault });
			return found ? found.name : '';
		},
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',
			setSetting: 'settings/setSetting',

			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setCategories: 'categories/setCategories',
			setCategory: 'categories/setCategory',

			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchItems: 'categories/asyncFetchData',

			destroyData: 'orders/destroyData',
			saveData: 'users/saveData',

			fetchSetting: 'settings/asyncFetchData',
			updateData: 'settings/updateData',

			//'resetMessages' : 'settings/resetMessages'
		}),
		toggle(event) {
			if (_.size(this.selectedall) === 0) {
				this.selected = [];
			} else {
				//console.log(this.selected[0])
				if (event[0] !== -1) {
					this.selected = [];
					_.forEach(this.getAttributes, cat => {
						this.selected.push(cat._id);
					});
				}
			}
		},
		toggleDrawerFilter() {
			this.setDrawerFilter(!this.getDrawerFilter);
			this.clippedOrder = 0;
			//this.$store.commit('setDrawer') = !this.$store.state.drawer;
		},
		toggleDrawerSort() {
			this.setDrawerFilter(0);
			this.clippedOrder = !this.clippedOrder;
			//this.$store.commit('setDrawer') = !this.$store.state.drawer;
		},
		download() {
			return 'categories/download?token=' + this.getToken + '&search=' + this.searchfield + '&categories=' + this.settings.filters.categories + '&selected=' + this.selected;
		},
		onResize() {
			this.isMobile = window.innerWidth < 769;
		},
		filterName(data) {
			return _.find(data, { lang: this.getLanguage }).text;
			//return text
		},

		changeStatus() {
			try {
				//console.log(this.getSettings.attributes)

				let url = 'profile/attributes';

				this.setPreload(true);
				axios
					.post(`${this.getUrl}${url}`, this.getAttributes, { headers: { Authorization: `Bearer ${this.getToken}` } })
					.then(({ data }) => {
						this.updateData(data.data);
					})
					.then(() => {
						//this.

						this.setPreload(false);

						this.setDialog(false);

						this.snackbar.color = 'success';
						this.snackbar.text = 'Update successfully';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.selected = [];
					})
					.catch(error => {
						console.log(error);
					});

				//console.log(response);
			} catch (err) {
				console.log(err);
			}

			//console.log(item)
		},

		async editItem(key = null) {
			this.componentKey += 1;
			this.setClearError({});
			//await this.resetMessages();
			//console.log(this.getOrders.indexOf(item));
			//console.log(item)
			this.operation = 'FormEdit';
			//var item =  this.getAttributes[this.selected[0]]
			// this.setIndex = this.selected[0]

			if (key) {
				//this.setIndex = _.findIndex(this.getAttributes, {'_id':key._id})
				this.setIndex = key._id;
			} else {
				//this.setIndex = _.findIndex(this.getAttributes, {'_id':this.selected[0]})
				this.setIndex = this.selected[0];
			}

			//console.log(item)

			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		async createItem() {
			this.componentKey += 1;
			this.setClearError({});
			//await this.resetMessages();
			//console.log(this.getOrders.indexOf(item));
			//console.log(item)
			this.operation = 'FormCreate';

			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
			/*Vue.component(
                    'FormEdit',
                    // A dynamic import returns a Promise.
                    () => import('@/components/orders/Edit.vue')
                )*/
		},
		async getFileCategories() {
			this.componentKey += 1;
			this.setClearError({});
			//await this.resetMessages();
			//console.log(this.getOrders.indexOf(item));
			//console.log(item)
			this.operation = 'FormFile';

			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},

		searchit: _.debounce(function () {
			if (_.size(this.searchfield) >= 3) {
				//var variants = _.filter(this.event.odds, mark => /^id=sr:matchmarket:/.test(mark._attributes.specifiers))
				//this.getAttributes = _.filter(this.getSettings.attributes,{trans:[{lang:this.langDefault,name: this.searchfield}]}) //name:
				var regexp = new RegExp(this.searchfield, 'i'); //regexp.test(name)
				//this.getAttributes = _.filter(this.getSettings.attributes,{trans:[{lang:this.langDefault,name: new RegExp(this.searchfield, 'g')}]}) //name:
				this.getAttributes = _.filter(this.getSettings.attributes, mark => regexp.test(mark.text)); //name:
				//this.getAttributes = _.filter(this.getSettings.attributes,obj => {trans:[{lang:this.langDefault,name: obj.}]}) //name:

				this.settings.search = this.searchfield;
				this.settings.options.page = 1;
			} else {
				this.settings.search = '';
				this.settings.options.page = 1;
				this.getAttributes = this.getSettings.attributes;
			}
		}, 1000),
		propSetMessages(text) {
			this.snackbar.color = 'success';
			this.snackbar.text = text;
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
			_.forEach(this.getSettings.attributes, attr => {
				if (_.size(attr.trans) > 0) {
					var text = _.find(attr.trans, { lang: this.langDefault });
					_.assignIn(attr, { text: text.name });
				}
			});
			this.getAttributes = this.getSettings.attributes;
			this.operation = '';
		},

		async openNew() {
			this.setClearError({});
			//await this.resetMessages();
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},

		/*checkpresenza(item) {
                return this.selected.includes(item)
            },
*/
		closeSnackbar() {
			this.setSnackbar(false);
		},
		async confirm() {
			/*let payload = this.form;
                try {
                    this.setPreload(true);
                    this.preload = true;
                    var response = await this.fetchUsers(payload);

                    this.getDataFromApi().then(res => {

                        this.snackbar.color = "success";
                        this.snackbar.text = this.$vuetify.lang.t(`$vuetify.messages.${data.data}`);
                        this.snackbar.snackbar = true;
                        this.snackbar.mode = 'multi-line';
                        this.snackbar.timeout = 5000;
                        this.setPreload(false);
                    })

                } catch (err) {
                    console.log(err);
                }
                this.preload = false;*/
		},

		deleteItem(item = null) {
			this.dialogconfirm = true;

			if (item) {
				this.form = item;
			}

			//this.selected = [];
			// this.selectedall = []
		},
		confirmDelete() {
			this.dialogconfirm = false;

			this.messages = [];
			var paypload = [];

			if (this.form && this.form._id) {
				this.selected = [this.form._id];
			}

			_.forEach(this.getSettings.attributes, cat => {
				if (!_.includes(this.selected, cat._id)) {
					paypload.push(cat);
				}
			});
			let url = 'profile/attributes';

			this.setPreload(true);
			axios
				.post(`${this.getUrl}${url}`, paypload, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					this.setPreload(false);
					this.setDialog(false);

					this.snackbar.color = 'success';
					this.snackbar.text = 'Update successfully';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					this.selected = [];
					this.selectedall = [];

					this.setSetting(data.data);

					this.langDefault = _.find(data.data.languages, { default: true }).lang;
					_.forEach(data.data.attributes, attr => {
						var text = _.find(attr.trans, { lang: this.langDefault });
						_.assignIn(attr, { text: text.name });
					});
					this.getAttributes = data.data.attributes;
				})
				.catch(error => {
					console.log(error);
				});
			//this.deleteCategories()
		},
	},
	beforeDestroy() {
		this.destroyData();

		//console.log('Main Vue destroyed')
	},
};
</script>

<style></style>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.snapshot-cards,
.snapshot-cards tr {
	display: block;
	width: 100%;
}
.snapshot-cards tr,
.snapshot-cards tr:hover {
	background: transparent !important;
}
.snapshot-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.snapshot-cards tr:first-child td {
	padding-top: 12px !important;
}
.snapshot-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.snapshot-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
/* card in lista fuori da v-data-table */
.kv-list > .kv-card + .kv-card {
	margin-top: 8px;
}
</style>
